var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22246(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22246",
    "data-name": "Group 22246",
    transform: "translate(-547 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22241",
    "data-name": "Group 22241",
    transform: "translate(252 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9056763_arrow_top_right_o_icon",
    "data-name": "9056763_arrow_top_right_o_icon",
    transform: "translate(563.786 2061.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27651",
    "data-name": "Path 27651",
    d: "M22.408,21.444H26.9V7.963H13.421v4.493h5.81L7.256,24.431l3.177,3.177L22.408,15.634Z",
    transform: "translate(7.8 8.681)",
    fill: "#6d4eec",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27652",
    "data-name": "Path 27652",
    d: "M1,25.714A24.714,24.714,0,1,1,25.714,50.428,24.714,24.714,0,0,1,1,25.714Zm4.493,0a20.22,20.22,0,1,1,20.22,20.22A20.22,20.22,0,0,1,5.493,25.714Z",
    transform: "translate(0 0)",
    fill: "#6d4eec",
    stroke: "#fff",
    strokeWidth: 0.8,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22246);
export default __webpack_public_path__ + "static/media/Group 22246.5f706ae4a4b0f5e00c8c0ff8fb1e7989.svg";
export { ForwardRef as ReactComponent };